module.exports = __webpack_public_path__ + "img/icon_surprises.b13b57b4.svg";